
  
  // Font selector toggles
  const fontSelectors = [
    // Recto
    {
      button: document.querySelector('[aria-controls="customizer-drawer-recto-initials-font"]'),
      targetId: 'customizer-drawer-recto-initials-font'
    },
    {
      button: document.querySelector('[aria-controls="customizer-drawer-recto-text-font"]'),
      targetId: 'customizer-drawer-recto-text-font'
    },
    {
      button: document.querySelector('[aria-controls="customizer-drawer-recto-illustration-font"]'),
      targetId: 'customizer-drawer-recto-illustration-font'
    },
    // Verso
    {
      button: document.querySelector('[aria-controls="customizer-drawer-verso-initials-font"]'),
      targetId: 'customizer-drawer-verso-initials-font'
    },
    {
      button: document.querySelector('[aria-controls="customizer-drawer-verso-text-font"]'),
      targetId: 'customizer-drawer-verso-text-font'
    },
    {
      button: document.querySelector('[aria-controls="customizer-drawer-verso-illustration-font"]'),
      targetId: 'customizer-drawer-verso-illustration-font'
    }
  ];

  fontSelectors.forEach(({button, targetId}) => {
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const targetDiv = document.getElementById(targetId);
        targetDiv.style.display = targetDiv.style.display === 'none' ? 'block' : 'none';
      });
    }
  });

  const initCounters = () => {
    const counters = {
      rectoInitials: {
        input: document.querySelector('#customizer-drawer-recto-initials [name="recto-initials"]'),
        counter: document.querySelector('#customizer-drawer-recto-initials .input-counter'),
        max: 2
      },
      rectoText: {
        input: document.querySelector('#customizer-drawer-recto-text [name="recto-initials"]'),
        counter: document.querySelector('#customizer-drawer-recto-text .input-counter'),
        max: 20
      },
      versoInitials: {
        input: document.querySelector('#customizer-drawer-verso-initials [name="verso-initials"]'),
        counter: document.querySelector('#customizer-drawer-verso-initials .input-counter'),
        max: 2
      },
      versoText: {
        input: document.querySelector('#customizer-drawer-verso-text [name="verso-initials"]'),
        counter: document.querySelector('#customizer-drawer-verso-text .input-counter'),
        max: 20
      }
    };

    Object.values(counters).forEach(({input, counter, max}) => {
      if (!input || !counter) return;

      const updateCount = () => {
        const count = input.value.length;
        counter.textContent = `${count}/${max}`;
      };

      input.addEventListener('input', updateCount);
      updateCount();
    });
  };
  
  // Call on page load
  initCounters();

  document.addEventListener('DOMContentLoaded', () => {
    const categoryBtns = document.querySelectorAll('.illustration-category-btn');
    const illustrations = document.querySelectorAll('.illustration-option');
  
    function showCategory(category, drawer) {
      // Get illustrations only from the specified drawer
      const drawerIllustrations = drawer.querySelectorAll('.illustration-option');
      
      drawerIllustrations.forEach(ill => {
        if (ill.dataset.category === category) {
          ill.classList.add('visible');
        } else {
          ill.classList.remove('visible');
        }
      });
    }
  
    // Show first category by default for both recto and verso drawers
    document.querySelectorAll('#customizer-drawer-recto-illustration, #customizer-drawer-verso-illustration').forEach(illustrations_block => {
      const firstBtn = illustrations_block.querySelector('.illustration-category-btn');
      if (firstBtn) {
        showCategory(firstBtn.dataset.category, illustrations_block);
      }
    });
  
    categoryBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        
        // Get the current drawer
        const illustrations_block = btn.closest('[id^="customizer-drawer-"]');
        
        // Only affect buttons in the same drawer
        illustrations_block.querySelectorAll('.illustration-category-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        
        showCategory(btn.dataset.category, illustrations_block);
      });
    });
  });



  // Add this to your existing DOMContentLoaded event handler
  document.addEventListener('DOMContentLoaded', () => {
    // Handle verso variant selection
    const versoVariantDivs = document.querySelectorAll('[aria-controls^="customizer-drawer-verso-"]');
    const form = document.querySelector('.customizer-form');
    const hiddenVariantInput = form.querySelector('input[name="id"]');
    const drawer = document.querySelector(`x-drawer`);
    
    console.log('Initial setup:', {
      numberOfVariantDivs: versoVariantDivs.length,
      hiddenInput: hiddenVariantInput?.value,
    });
    
    versoVariantDivs.forEach(div => {
      div.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Variant div clicked:', div.getAttribute('aria-controls'));
        
        // Select the radio inside the clicked div
        const radio = div.querySelector('input[type="radio"]');
        console.log('Found radio:', {
          radio: radio?.value,
          variantId: radio?.dataset.variantId
        });
        
        radio.checked = true;
        
        // Update hidden variant input
        if (radio && hiddenVariantInput) {
          console.log('Updating hidden input:', {
            from: hiddenVariantInput.value,
            to: radio.dataset.variantId
          });
          hiddenVariantInput.value = radio.dataset.variantId;
        } else {
          console.warn('Missing elements:', {
            radio: !!radio,
            hiddenInput: !!hiddenVariantInput
          });
        }
        
        // Hide all variant sections
        const sections = document.querySelectorAll('[id^="customizer-drawer-verso-"]');
        console.log('Hiding sections:', sections.length);
        
        sections.forEach(section => {
          section.style.display = 'none';
        });
        
        // Show the target section
        const targetId = div.getAttribute('aria-controls');
        const targetSection = document.getElementById(targetId);
        console.log('Showing section:', {
          targetId,
          found: !!targetSection
        });
        
        if (targetSection) {
          targetSection.style.display = 'flex';
        }
        
        // Update active state on divs
        versoVariantDivs.forEach(d => d.classList.remove('active'));
        div.classList.add('active');
        console.log('Updated active states');
      });
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.customizer-form');
    const hiddenVariantInput = form.querySelector('input[name="id"]');
    const drawer = document.querySelector('.customizer-drawer');
    let complementaryProducts = [];
    let accessoryProducts = [];

    // Add event listeners for complementary products
    document.querySelectorAll('.customizer-add-to-cart-complementary').forEach(button => {
      button.addEventListener('click', (e) => {
        console.log('Complementary product button clicked:', button.dataset.productId);
        e.preventDefault();
        const productId = button.dataset.productId;
        if (!complementaryProducts.includes(productId)) {
          complementaryProducts.push(productId);
          button.textContent = 'Ajouté';
          button.classList.add('button--secondary');
        } else {
          complementaryProducts = complementaryProducts.filter(id => id !== productId);
          button.textContent = 'Ajouter au panier';
          button.classList.remove('button--secondary');
        }
      });
    });

    // Add event listeners for accessory products (just track them, don't add to cart yet)
    document.querySelectorAll('.accessory-product-add, .accessory-product-remove').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const card = this.closest('.accessory-product-card');
        const productId = this.dataset.productId;
        
        if (this.classList.contains('accessory-product-add')) {
          // Toggle selected state
          card.classList.add('selected');
          
          // Add to tracking array if not already there
          if (!accessoryProducts.includes(productId)) {
            accessoryProducts.push(productId);
            console.log('Accessory product added to queue:', productId);
            
            // Show message textarea if this is the specific product (43038498291781)
            if (productId == "43038498291781") {
              console.log('show message textarea');
              const messageTextarea = card.nextElementSibling;
              if (messageTextarea && messageTextarea.classList.contains('product-message-textarea')) {
                messageTextarea.style.display = 'block';
              }
            }
          }
        } else {
          // Toggle selected state
          card.classList.remove('selected');
          
          // Remove from tracking array
          accessoryProducts = accessoryProducts.filter(id => id !== productId);
          console.log('Accessory product removed from queue:', productId);
          
          // Hide message textarea if this is the specific product (43038498291781)
          if (productId == "43038498291781") {
            const messageTextarea = card.nextElementSibling;
            if (messageTextarea && messageTextarea.classList.contains('product-message-textarea')) {
              messageTextarea.style.display = 'none';
              // Clear the textarea
              const textarea = messageTextarea.querySelector('.message-textarea');
              if (textarea) {
                textarea.value = '';
              }
            }
          }
        }
      });
    });
    
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const variantId = hiddenVariantInput.value;
      const formData = new FormData(form);
      
      // Filter only properties[] entries
      const properties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          const propertyName = key.slice(11, -1);
          properties[propertyName] = value;
        }
      }

      // Prepare cart items array with main product and complementary products
      const items = [{
        id: variantId,
        quantity: 1,
        properties
      }];

      // Add complementary products
      complementaryProducts.forEach(productId => {
        items.push({
          id: productId,
          quantity: 1
        });
      });

      // Add accessory products with message properties if applicable
      accessoryProducts.forEach(productId => {
        const itemProperties = {};
        
        // Check if this product has a message textarea
        const messageTextarea = document.querySelector(`#message-${productId}`);
        if (messageTextarea && messageTextarea.value.trim()) {
          itemProperties.Message = messageTextarea.value.trim();
        }
        
        const accessoryItem = {
          id: productId,
          quantity: 1
        };
        
        // Only add properties if there are any
        if (Object.keys(itemProperties).length > 0) {
          accessoryItem.properties = itemProperties;
        }
        
        items.push(accessoryItem);
      });

      console.log('Items to submit:', items);
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        });

        const result = await response.json();
        console.log('Add to cart result:', result);

        // Reset complementary products state
        complementaryProducts = [];
        document.querySelectorAll('.customizer-add-to-cart-complementary').forEach(button => {
          button.textContent = 'Ajouter au panier';
          button.classList.remove('button--secondary');
        });

        // Reset accessory products state
        accessoryProducts = [];
        document.querySelectorAll('.accessory-product-card').forEach(card => {
          card.classList.remove('selected');
        });
        document.querySelectorAll('.product-message-textarea').forEach(textarea => {
          textarea.style.display = 'none';
        });

        // Trigger cart refresh to update cart drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // Wait a moment for cart to refresh, then open drawer
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.show();
          }
        }, 100);

        // Close the customizer drawer after successful addition
        if (drawer) {
          drawer.hide();
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        document.dispatchEvent(new CustomEvent('cart:error', {
          detail: { error: error.message }
        }));
      }
    });
  });



  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.customizer-form');
    
    // Function to collect and log current properties
    const logCurrentProperties = () => {
      const formData = new FormData(form);
      const properties = Object.fromEntries(formData);
      
      console.log('Current Properties:', properties);
    };

    // Listen for changes on all inputs
    form.querySelectorAll('input').forEach(input => {
      if (input.type === 'text') {
        input.addEventListener('input', () => {
          console.log('Text input changed:', {
            name: input.name,
            value: input.value
          });
          logCurrentProperties();
        });
      }
      
      if (input.type === 'radio') {
        input.addEventListener('change', () => {
          console.log('Radio changed:', {
            name: input.name,
            value: input.value,
            checked: input.checked
          });
          logCurrentProperties();
        });
      }
    });
  });

  // === Custom: Update first gallery image on variant change (robust version) ===
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail?.variant;
    if (!variant || !variant.featured_media) return;

    // Update main product gallery
    const mainGallery = document.querySelector('.product-gallery__carousel');
    if (mainGallery) {
      const firstMedia = mainGallery.querySelector('.product-gallery__media img');
      if (firstMedia) {
        const newSrc = variant.featured_media.preview_image?.src?.replace(/^\/\//, 'https://') || '';
        if (newSrc) {
          firstMedia.src = newSrc;
          firstMedia.srcset = '';
        }
        if (variant.featured_media.alt) {
          firstMedia.alt = variant.featured_media.alt;
        }
      }
    }

    // Update customizer drawer gallery
    const customizerGallery = document.querySelector('.product-drawer-gallery');
    if (customizerGallery) {
      const firstSlide = customizerGallery.querySelector('.product-drawer-gallery__slide');
      if (firstSlide) {
        const firstImage = firstSlide.querySelector('.product-drawer-gallery__image');
        if (firstImage) {
          const newSrc = variant.featured_media.preview_image?.src?.replace(/^\/\//, 'https://') || '';
          if (newSrc) {
            firstImage.src = newSrc;
            firstImage.srcset = '';
          }
          if (variant.featured_media.alt) {
            firstImage.alt = variant.featured_media.alt;
          }
        }
      }
    }
  });

  // === Custom: Show/hide variant-specific option groups in customizer ===
  (function() {
    function updateVariantOptionGroups(selectedVariantId) {
      const groups = document.querySelectorAll('.variant-options-group[data-variant-id]');
      groups.forEach(group => {
        const id = group.getAttribute('data-variant-id');
        const isActive = (id === String(selectedVariantId));
        group.style.display = isActive ? 'flex' : 'none';

        // Enable inputs for the active group, disable for hidden groups so they don't submit
        group.querySelectorAll('input, select, textarea').forEach(el => {
          el.disabled = !isActive;
        });
      });
    }

    // Initialize on DOM ready using hidden input from customizer form
    document.addEventListener('DOMContentLoaded', () => {
      const hiddenVariantInput = document.querySelector('.customizer-form input[name="id"]');
      if (hiddenVariantInput && hiddenVariantInput.value) {
        updateVariantOptionGroups(hiddenVariantInput.value);
      } else {
        // If no hidden input is found, ensure hidden groups are disabled by default
        document.querySelectorAll('.variant-options-group[data-variant-id]').forEach(group => {
          const isVisible = group.style.display !== 'none';
          group.querySelectorAll('input, select, textarea').forEach(el => {
            el.disabled = !isVisible;
          });
        });
      }
    });

    // React to variant changes from the product form/variant picker
    document.addEventListener('variant:change', function(event) {
      const selected = event.detail?.variant;
      if (selected && selected.id) {
        updateVariantOptionGroups(selected.id);
      }
    });
  })();

  // === Custom: Prevent scroll on variant change in ProductGallery ===
  (function() {
    // Wait until ProductGallery is defined
    if (!window.customElements.get('product-gallery')) return;

    const ProductGalleryProto = window.customElements.get('product-gallery').prototype;
    if (!ProductGalleryProto) return;

    // Find the original onVariantChange function
    const originalConnectedCallback = ProductGalleryProto.connectedCallback;
    ProductGalleryProto.connectedCallback = function() {
      // Call the original
      if (originalConnectedCallback) originalConnectedCallback.call(this);
      // Remove scrollIntoView from onVariantChange
      const self = this;
      const form = document.forms[this.getAttribute('form')];
      if (!form) return;
      // Remove any previous listener
      form.removeEventListener('variant:change', self._customNoScrollVariantChange);
      // Add our custom handler
      self._customNoScrollVariantChange = function(event) {
        if (!event.detail?.variant) return;
        // Only update image, do not scroll
        // (Let custom.js handle the image update)
      };
      form.addEventListener('variant:change', self._customNoScrollVariantChange);
    };
  })();

  // === Custom: Feedback for message textarea ===
  document.addEventListener('DOMContentLoaded', () => {
    const messageSubmitButtons = document.querySelectorAll('.message-submit-btn');
    
    messageSubmitButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        
        const variantId = button.dataset.variantId;
        const textarea = document.querySelector(`#message-${variantId}`);
        const message = textarea.value.trim();
        
        if (!message) {
          alert('Veuillez entrer un message avant de sauvegarder.');
          return;
        }
        
        // Just show feedback that message will be saved when product is added to cart
        button.textContent = 'Sauvegardé!';
        button.classList.add('button--secondary');
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.textContent = 'Sauvegarder';
          button.classList.remove('button--secondary');
        }, 2000);
        
        console.log('Message will be saved with product:', variantId, message);
      });
    });
  });

  // === Custom: Product Drawer Gallery Slider ===
  document.addEventListener('DOMContentLoaded', () => {
    const galleries = document.querySelectorAll('.product-drawer-gallery');
    
    galleries.forEach(gallery => {
      const slider = gallery.querySelector('.product-drawer-gallery__slider');
      const slides = gallery.querySelectorAll('.product-drawer-gallery__slide');
      const prevBtn = gallery.querySelector('.product-drawer-gallery__nav--prev');
      const nextBtn = gallery.querySelector('.product-drawer-gallery__nav--next');
      
      if (!slider || slides.length <= 3) return;
      
      let currentIndex = 0;
      const totalSlides = slides.length;
      const slidesPerView = 3;
      const maxIndex = totalSlides - slidesPerView;
      
      function updateSlider() {
        // Calculate the slide width including gap
        const slideWidth = 100 / slidesPerView;
        const gapWidth = (8 / slider.offsetWidth) * 100; // Convert 8px gap to percentage
        const slideWidthWithGap = slideWidth + (gapWidth / slidesPerView);
        
        const translateX = -currentIndex * slideWidthWithGap;
        slider.style.transform = `translateX(${translateX}%)`;
        
        // Update button states
        if (prevBtn) {
          prevBtn.disabled = currentIndex === 0;
        }
        if (nextBtn) {
          nextBtn.disabled = currentIndex >= maxIndex;
        }
      }
      
      function nextSlide() {
        if (currentIndex < maxIndex) {
          currentIndex++;
          updateSlider();
        }
      }
      
      function prevSlide() {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      }
      
      // Add event listeners
      if (nextBtn) {
        nextBtn.addEventListener('click', nextSlide);
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', prevSlide);
      }
      
      // Initialize slider
      updateSlider();
      
      // Add keyboard navigation
      gallery.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextSlide();
        }
      });
      
      // Make gallery focusable for keyboard navigation
      gallery.setAttribute('tabindex', '0');
      
      // Hide navigation buttons if there are 3 or fewer slides
      if (slides.length <= 3) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      }
    });
  });

  // === Custom: Update selected option display ===
  document.addEventListener('DOMContentLoaded', () => {
    // Function to update the selected option display
    function updateSelectedOptionDisplay(radio) {
      
      
      const wrapper = radio.closest('.option-product-item-wrapper');
      if (!wrapper) return;
      
      const label = wrapper.querySelector('.option-product-item__label');
      if (!label) return;

      const customizerStep = radio.closest('.customizer-step');
      
      const selectedWrapper = customizerStep.querySelector('.option-product-selected-wrapper');
      if (!selectedWrapper) return;
      
      if (radio.checked) {
        selectedWrapper.textContent = label.textContent;
        selectedWrapper.style.display = 'block';
      } else {
        // Check if any other radio in the same group is selected
        const radioName = radio.name;
        const sameGroupRadios = document.querySelectorAll(`input[name="${radioName}"]`);
        const anySelected = Array.from(sameGroupRadios).some(r => r.checked);
        
        if (!anySelected) {
          selectedWrapper.textContent = '';
          selectedWrapper.style.display = 'none';
        }
      }
    }
    
    // Add event listeners to all radio buttons in option-product-item-wrapper
    document.querySelectorAll('.option-product-item-wrapper input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        updateSelectedOptionDisplay(radio);
      });
    });
    
    // Initialize display for already selected radios
    document.querySelectorAll('.option-product-item-wrapper input[type="radio"]:checked').forEach(radio => {
      updateSelectedOptionDisplay(radio);
    });
  });

  // === Popin Info Handler ===
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.popin-info-link').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const wrapper = link.closest('.popin-info-wrapper');
        const content = wrapper.querySelector('.popin-info-content');
        
        // Toggle popin
        content.classList.toggle('active');
      });
    });
    
    // Close button functionality
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('popin-info-close')) {
        e.preventDefault();
        e.stopPropagation();
        const content = e.target.closest('.popin-info-content');
        content.classList.remove('active');
      }
    });
    
    // Close popin when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.popin-info-wrapper')) {
        document.querySelectorAll('.popin-info-content').forEach(content => {
          content.classList.remove('active');
        });
      }
    });
  });

  // === Custom: Sync customizer form hidden input with main variant picker selection ===
  document.addEventListener('variant:change', (event) => {
    const customizerForm = document.querySelector('.customizer-form');
    if (!customizerForm) return;

    const hiddenVariantInput = customizerForm.querySelector('input[name="id"]');
    if (!hiddenVariantInput) return;

    const variant = event.detail?.variant;
    if (!variant || !variant.id) return;

    hiddenVariantInput.value = variant.id;
  });

  // === Custom: Handle clicks on customizer-drawer__option elements ===
  document.addEventListener('DOMContentLoaded', () => {
    // Use event delegation to handle clicks on customizer-drawer__option elements
    document.addEventListener('click', (e) => {
      const optionElement = e.target.closest('.customizer-drawer__option');
      if (!optionElement) return;
      
      // Prevent default behavior
      e.preventDefault();
      
      // Find the radio input inside the clicked option
      const radioInput = optionElement.querySelector('input[type="radio"]');
      if (!radioInput) return;
      
      // Select the radio
      radioInput.checked = true;
      
      // Remove active class from all options in the same group (same radio name)
      const radioName = radioInput.name;
      document.querySelectorAll(`.customizer-drawer__option`).forEach(option => {
        const radio = option.querySelector('input[type="radio"]');
        if (radio && radio.name === radioName) {
          option.classList.remove('active');
        }
      });
      
      // Add active class to the clicked option
      optionElement.classList.add('active');
      
      // Trigger change event on the radio to ensure any other listeners are notified
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });